module.exports = __webpack_public_path__ + "img/2.030eb85d.png";